import { forwardRef, createElement } from 'react';

function IconTransferCancel(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, createElement("path", {
    d: "M18.804 15.647a.75.75 0 011.049 1.05l-.073.083-1.969 1.97 1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073-1.97-1.969-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083 1.969-1.97-1.97-1.97a.75.75 0 01.977-1.133l.084.073 1.97 1.969 1.97-1.97.084-.072z",
    fill: "#CF3C16",
    fillRule: "nonzero"
  }), createElement("path", {
    d: "M5.5 16.5v3.75a.25.25 0 00.193.243l.057.007H12V22H5.75A1.75 1.75 0 014 20.25V16.5h1.5zm2.946-6.103l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H2.75a.75.75 0 01-.102-1.493l.102-.007h6.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V14h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v7.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zm.914 2.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
    fill: "currentColor"
  })));
}

var TransferCancel = /*#__PURE__*/forwardRef(IconTransferCancel);

export default TransferCancel;
//# sourceMappingURL=TransferCancel.js.map
